import { useEffect, useState } from "react";
import type { LearningPackagePayload } from "../services/learningPackageService";
import { fetchLearningPackages } from "../services/learningPackageService";

export const useLearningPackages = () => {
  const [packages, setPackages] = useState<LearningPackagePayload[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchLearningPackages();
        if (isMounted) setPackages(data);
      } catch (err) {
        console.error("Failed to load learning packages", err);
        if (isMounted) {
          setError(err instanceof Error ? err.message : "Failed to load learning packages");
          setPackages([]);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    load();
    return () => {
      isMounted = false;
    };
  }, []);

  return { packages, loading, error };
};
